/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { EHealthCheckRequestState } from '../../../device-health-check/models';
import { DeviceHealthCheckActions, EDeviceHealthCheckActions } from '../actions';

import { IDeviceHealthCheckState, initialDeviceHealthCheckState } from '../state';

export function deviceHealthCheckReducer(state = initialDeviceHealthCheckState, action: DeviceHealthCheckActions): IDeviceHealthCheckState {
  switch (action.type) {
    case EDeviceHealthCheckActions.GetVehicleSpecificationSuccess: {
      return {
        ...state,
        vehicleWithBoxResponse: action.payload
      };
    }

    case EDeviceHealthCheckActions.GetVehicleWithEsn: {
      return {
        ...state,
        historyLoading: true,
        pingRequestTransactionId: initialDeviceHealthCheckState.pingRequestTransactionId,
        pingState: initialDeviceHealthCheckState.pingState,
        resetState: initialDeviceHealthCheckState.resetState
      };
    }

    case EDeviceHealthCheckActions.GetVehicleWithEsnSuccess: {
      return {
        ...state,
        vehicleWithEsnResponse: action.payload
      };
    }

    case EDeviceHealthCheckActions.GetSelectedStatusItemId: {
      return {
        ...state,
        selectedStatusItemId: action.payload
      };
    }

    case EDeviceHealthCheckActions.SendPing:
    case EDeviceHealthCheckActions.PingResponsePending: {
      return {
        ...state,
        pingState: EHealthCheckRequestState.Pending,
        resetState: EHealthCheckRequestState.NotSent
      };
    }

    case EDeviceHealthCheckActions.SendPingSuccess: {
      return {
        ...state,
        pingRequestTransactionId: action.payload?.transactionId
      };
    }

    case EDeviceHealthCheckActions.SendPingFailure:
    case EDeviceHealthCheckActions.PingResponseFailure: {
      return {
        ...state,
        pingState: EHealthCheckRequestState.Failure,
        resetState: EHealthCheckRequestState.NotSent
      };
    }

    case EDeviceHealthCheckActions.PingResponseSuccess: {
      return {
        ...state,
        pingState: EHealthCheckRequestState.Success,
        resetState: EHealthCheckRequestState.NotSent
      };
    }

    case EDeviceHealthCheckActions.SendReset:
    case EDeviceHealthCheckActions.ResetResponsePending: {
      return {
        ...state,
        resetState: EHealthCheckRequestState.Pending
      };
    }

    case EDeviceHealthCheckActions.SendResetFailure:
    case EDeviceHealthCheckActions.ResetResponseFailure: {
      return {
        ...state,
        resetState: EHealthCheckRequestState.Failure
      };
    }

    case EDeviceHealthCheckActions.ResetResponseSuccess: {
      return {
        ...state,
        resetState: EHealthCheckRequestState.Success
      };
    }

    case EDeviceHealthCheckActions.GetHistory: {
      return {
        ...state,
        historyLoading: true
      };
    }

    case EDeviceHealthCheckActions.GetHistorySuccess: {
      return {
        ...state,
        history: action.payload,
        historyLoading: false
      };
    }

    default:
      return state;
  }
}
